export const PROFILE_INFO_MODE = Object.freeze({
  DYNAMIC: "dynamic",
  PARTICIPANT: "participant",
  STAFF: "staff",
})

export const SIDEBAR_CONTENT_GROUP = Object.freeze({
  ACTIVITY: "activity",
  APPLICATION: "application",
  DASHBOARD: "dashboard",
  ENTERPRISE: "enterprise",
  GROUP_SESSION: "group_session",
  LIBRARY: "library",
  ORGANIZATION: "organization",
  PARTICIPANT: "participant",
  SERVICES: "services",
  STAFF: "staff",
})
